// import React, { useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";
// import { useLanguage } from "../context/LanguageContext";

// const BannersCarousel = ({
//     banners = [],
//     className = "",
//     autoPlay = true,
//     interval = 5000,
//     use1080 = false
// }) => {
//     const { language } = useLanguage();
//     const isRTL = language === 'ar';
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [touchStart, setTouchStart] = useState(null);
//     const [touchEnd, setTouchEnd] = useState(null);

//     // Minimum swipe distance
//     const minSwipeDistance = 50;

//     const onTouchStart = (e) => {
//         setTouchEnd(null);
//         setTouchStart(e.targetTouches[0].clientX);
//     };

//     const onTouchMove = (e) => {
//         setTouchEnd(e.targetTouches[0].clientX);
//     };

//     const onTouchEnd = () => {
//         if (!touchStart || !touchEnd) return;
//         const distance = touchStart - touchEnd;
//         const isLeftSwipe = distance > minSwipeDistance;
//         const isRightSwipe = distance < -minSwipeDistance;
//         if (isLeftSwipe) {
//             nextSlide(null);
//         }
//         if (isRightSwipe) {
//             prevSlide(null);
//         }
//     };

//     useEffect(() => {
//         if (!autoPlay || banners.length <= 1) return;

//         const timer = setInterval(() => {
//             setCurrentIndex((prev) => (prev + 1) % banners.length);
//         }, interval);

//         return () => clearInterval(timer);
//     }, [autoPlay, interval, banners.length]);

//     const nextSlide = (e) => {
//         e?.stopPropagation();
//         setCurrentIndex((prev) => (prev + 1) % banners.length);
//     };

//     const prevSlide = (e) => {
//         e?.stopPropagation();
//         setCurrentIndex((prev) => (prev - 1 + banners.length) % banners.length);
//     };

//     if (!banners.length) return null;

//     return (
//         <div
//             dir="ltr"
//             className={`
//         relative
//         w-full
//         overflow-hidden
//         bg-gray-900
//         ${use1080 ? "aspect-[1920/1080]" : "aspect-[1920/855]"}
//         group
//         ${className}
//       `}
//             onTouchStart={onTouchStart}
//             onTouchMove={onTouchMove}
//             onTouchEnd={onTouchEnd}
//         >
//             {banners.map((banner, index) => (
//                 <div
//                     key={index}
//                     className={`
//             absolute
//             inset-0
//             w-full
//             h-full
//             transition-opacity duration-1000 ease-in-out
//             ${index === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}
//           `}
//                 >
//                     {/* Background Image */}
//                     <img
//                         src={banner.image}
//                         alt={banner.title || "Banner Image"}
//                         className="w-full h-full object-cover object-center"
//                     />

//                     {/* Overlay Content */}
//                     <div className={`absolute inset-0 flex flex-col justify-center items-start ${isRTL ? 'text-right' : 'text-left'} pl-2 pr-4 md:pr-16 lg:pr-24`}>
//                         <div
//                             dir={isRTL ? 'rtl' : 'ltr'}
//                             className={`
//       transition-all duration-700 delay-300 transform
//       ${index === currentIndex ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}
//       bg-gradient-to-r from-black/20 via-black/10 to-black/0
//       rounded-2xl
//       p-6 md:p-10 lg:p-12
//       max-w-4xl
//       text-white
//     `}
//                         >
//                             {banner.title && (
//                                 <h2 className="text-lg md:text-5xl lg:text-6xl font-extrabold mb-2 md:mb-4 tracking-tight leading-tight">
//                                     {banner.title}
//                                 </h2>
//                             )}

//                             {banner.subtitle && (
//                                 <p className="text-xs md:text-xl lg:text-2xl mb-4 md:mb-8 max-w-3xl font-light leading-relaxed">
//                                     {banner.subtitle.length > 40 ? (
//                                         (() => {
//                                             const i = banner.subtitle.lastIndexOf(" ", 40);
//                                             return (
//                                                 <>
//                                                     {banner.subtitle.slice(0, i > 0 ? i : 40)}
//                                                     <br />
//                                                     {banner.subtitle.slice(i > 0 ? i + 1 : 40)}
//                                                 </>
//                                             );
//                                         })()
//                                     ) : (
//                                         banner.subtitle
//                                     )}
//                                 </p>
//                             )}


//                             {banner.buttonText && banner.buttonLink && (
//                                 <a
//                                     href={banner.buttonLink}
//                                     className="
//           inline-block
//           bg-white
//           text-black
//           hover:bg-gray-200
//           font-semibold
//           px-2
//           py-1
//           md:px-8
//           md:py-3
//           text-[8px]
//           md:text-lg
//           rounded-full
//           transition-all
//           duration-300
//           transform
//           hover:scale-105
//         "
//                                 >
//                                     {banner.buttonText}
//                                 </a>
//                             )}
//                         </div>
//                     </div>


//                 </div>
//             ))}

//             {/* Navigation Arrows */}
//             {banners.length > 1 && (
//                 <>
//                     <button
//                         onClick={prevSlide}
//                         className="
//     hidden md:block
//     absolute
//     left-2
//     top-1/2
//     -translate-y-1/2
//     p-3
//     rounded-full
//     text-white
//     bg-gradient-to-r from-black/40 via-black/10 to-black/0
//     hover:bg-gradient-to-r hover:from-black/60 hover:via-black/40 hover:to-black/10
//     transition-all
//     duration-300
//     opacity-0
//     group-hover:opacity-100
//     z-20
//   "
//                         aria-label="Previous Slide"
//                     >
//                         <ChevronLeft size={32} />
//                     </button>

//                     <button
//                         onClick={nextSlide}
//                         className="
//     hidden md:block
//     absolute
//     right-2
//     top-1/2
//     -translate-y-1/2
//     p-3
//     rounded-full
//     text-white
//     bg-gradient-to-l from-black/40 via-black/10 to-black/0
//     hover:bg-gradient-to-l hover:from-black/60 hover:via-black/40 hover:to-black/10
//     transition-all
//     duration-300
//     opacity-0
//     group-hover:opacity-100
//     z-20
//   "
//                         aria-label="Next Slide"
//                     >
//                         <ChevronRight size={32} />
//                     </button>


//                     {/* Pagination Dots */}
//                     <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 z-20">
//                         {banners.map((_, idx) => (
//                             <button
//                                 key={idx}
//                                 onClick={() => setCurrentIndex(idx)}
//                                 className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex
//                                     ? 'bg-white w-8'
//                                     : 'bg-white/50 hover:bg-white/80 w-2'
//                                     }`}
//                                 aria-label={`Go to slide ${idx + 1}`}
//                             />
//                         ))}
//                     </div>
//                 </>
//             )}


//             {/* Disclaimer */}
//             <div className="absolute bottom-2 right-4 z-20 pointer-events-none">
//                 <p className="text-[10px] md:text-xs text-white/60 drop-shadow-md">
//                     Images shown for illustration purposes only.
//                 </p>
//             </div>
//         </div >
//     );
// };

// export default BannersCarousel;


import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";

const BannersCarousel = ({
    banners = [],
    className = "",
    autoPlay = true,
    interval = 5000,
    use1080 = false
}) => {
    const { language } = useLanguage();
    const isRTL = language === "ar";
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const navigate = useNavigate();

    // Minimum swipe distance
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        if (isLeftSwipe) {
            nextSlide(null);
        }
        if (isRightSwipe) {
            prevSlide(null);
        }
    };

    useEffect(() => {
        if (!autoPlay || banners.length <= 1) return;

        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % banners.length);
        }, interval);

        return () => clearInterval(timer);
    }, [autoPlay, interval, banners.length]);

    const nextSlide = (e) => {
        e?.stopPropagation();
        setCurrentIndex((prev) => (prev + 1) % banners.length);
    };

    const prevSlide = (e) => {
        e?.stopPropagation();
        setCurrentIndex((prev) => (prev - 1 + banners.length) % banners.length);
    };

    if (!banners.length) return null;

    return (
        <div
            dir="ltr"
            className={`
        relative
        w-full
        overflow-hidden
        bg-gray-900
        ${use1080 ? "aspect-[1920/1080]" : "aspect-[1920/855]"}
        group
        ${className}
      `}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
        >
            {banners.map((banner, index) => (
                <div
                    key={index}
                    
                    // onClick={() =>
                    //     navigate(`/landing-page/${encodeURIComponent(banner.title)}`, {
                    //         state: banner,
                    //     })
                    // }
                    className={`
            absolute
            inset-0
            w-full
            h-full
            transition-opacity duration-1000 ease-in-out
            ${index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"}
          `}
                >
                    {/* Background Image */}
                    <img
                        src={banner.image}
                        alt={banner.title || "Banner Image"}
                        className="w-full h-full object-cover object-center"
                    />

                    {/* Overlay Content */}
                    <div
                        className={`absolute inset-0 flex flex-col justify-center items-start ${isRTL ? "text-right" : "text-left"
                            } pl-2 pr-4 md:pr-16 lg:pr-24`}
                    >
                        <div
                            dir={isRTL ? "rtl" : "ltr"}
                            className={`
                transition-all duration-700 delay-300 transform
                ${index === currentIndex
                                    ? "translate-y-0 opacity-100"
                                    : "translate-y-10 opacity-0"
                                }
                bg-gradient-to-r from-black/20 via-black/10 to-black/0
                rounded-2xl
                p-6 md:p-10 lg:p-12
                max-w-4xl
                text-white
              `}
                        >
                            {banner.title && (
                                <h2 className="text-lg md:text-5xl lg:text-6xl font-extrabold mb-2 md:mb-4 tracking-tight leading-tight">
                                    {banner.title}
                                </h2>
                            )}

                            {banner.subtitle && (
                                <p className="text-xs md:text-xl lg:text-2xl mb-4 md:mb-8 max-w-3xl font-light leading-relaxed">
                                    {banner.subtitle.length > 40 ? (
                                        (() => {
                                            const i = banner.subtitle.lastIndexOf(" ", 40);
                                            return (
                                                <>
                                                    {banner.subtitle.slice(0, i > 0 ? i : 40)}
                                                    <br />
                                                    {banner.subtitle.slice(i > 0 ? i + 1 : 40)}
                                                </>
                                            );
                                        })()
                                    ) : (
                                        banner.subtitle
                                    )}
                                </p>
                            )}

                            {banner.buttonText && banner.buttonLink && (
                                <a
                                    href={banner.buttonLink}
                                    onClick={(e) => e.stopPropagation()}
                                    className="
                    inline-block
                    bg-white
                    text-black
                    hover:bg-gray-200
                    font-semibold
                    px-2
                    py-1
                    md:px-8
                    md:py-3
                    text-[8px]
                    md:text-lg
                    rounded-full
                    transition-all
                    duration-300
                    transform
                    hover:scale-105
                  "
                                >
                                    {banner.buttonText}
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            ))}

            {/* Navigation Arrows */}
            {banners.length > 1 && (
                <>
                    <button
                        onClick={prevSlide}
                        className="
              hidden md:block
              absolute
              left-2
              top-1/2
              -translate-y-1/2
              p-3
              rounded-full
              text-white
              bg-gradient-to-r from-black/40 via-black/10 to-black/0
              hover:bg-gradient-to-r hover:from-black/60 hover:via-black/40 hover:to-black/10
              transition-all
              duration-300
              opacity-0
              group-hover:opacity-100
              z-20
            "
                        aria-label="Previous Slide"
                    >
                        <ChevronLeft size={32} />
                    </button>

                    <button
                        onClick={nextSlide}
                        className="
              hidden md:block
              absolute
              right-2
              top-1/2
              -translate-y-1/2
              p-3
              rounded-full
              text-white
              bg-gradient-to-l from-black/40 via-black/10 to-black/0
              hover:bg-gradient-to-l hover:from-black/60 hover:via-black/40 hover:to-black/10
              transition-all
              duration-300
              opacity-0
              group-hover:opacity-100
              z-20
            "
                        aria-label="Next Slide"
                    >
                        <ChevronRight size={32} />
                    </button>

                    {/* Pagination Dots */}
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 z-20">
                        {banners.map((_, idx) => (
                            <button
                                key={idx}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentIndex(idx);
                                }}
                                className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex
                                        ? "bg-white w-8"
                                        : "bg-white/50 hover:bg-white/80 w-2"
                                    }`}
                                aria-label={`Go to slide ${idx + 1}`}
                            />
                        ))}
                    </div>
                </>
            )}

            {/* Disclaimer */}
            <div className="absolute bottom-2 right-4 z-20 pointer-events-none">
                <p className="text-[10px] md:text-xs text-white/60 drop-shadow-md">
                    Images shown for illustration purposes only.
                </p>
            </div>
        </div>
    );
};

export default BannersCarousel;

